
import BotFeaturesCheckboxGroup from '@/components/bot/BotFeaturesCheckboxGroup.vue';
import { ANALYTICS_FEATURES, DOMAIN_FEATURE_MAP, INTEGRATION_FEATURES } from '@/constants';
import { BotSettings, SelectOption } from '@/types';
import { BotDomain, SupportedFeature } from 'ignite360-core';
import { Component, Prop, Vue } from 'vue-property-decorator';
import InviteCollaboratorModal from '@/components/bot/InviteCollaboratorModal.vue';
import { AuthMixin } from '@/mixins/AuthMixin';
import { mixins } from 'vue-class-component';
import { tenantId } from '@/constants';

@Component({
  name: 'bot-form',
  components: { InviteCollaboratorModal, BotFeaturesCheckboxGroup },
})
export default class BotForm extends mixins(AuthMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: BotSettings;

  showInviteCollaboratorModal = false;

  onInput(key: keyof BotSettings, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  get domainSelectOptions(): SelectOption[] {
    const options = [{ value: BotDomain.Generic, label: 'General', disabled: false }];

    if (tenantId === 'ignite360') {
      options.push({ value: BotDomain.Restaurant, label: 'Restaurant', disabled: false });
      options.push({ value: BotDomain.RealEstate, label: 'Real Estate', disabled: false });
    }

    // if (tenantId === 'wedding') {
    options.push({ value: BotDomain.Wedding, label: 'Wedding', disabled: false });
    // }
    // if (tenantId === 'wlcmHome') {
    options.push({ value: BotDomain.WlcmHome, label: 'WLCM Home', disabled: false });
    // }

    return options;
  }

  get showTimezoneInput() {
    return [BotDomain.RealEstate, BotDomain.Restaurant].includes(this.value.domain);
  }

  get showEnvironmentInput() {
    return [BotDomain.RealEstate, BotDomain.Restaurant].includes(this.value.domain);
  }

  get showDomainInput() {
    return true;
    // return ['tanis', 'ignite360'].includes(tenantId);
  }

  get showContentModulesInput() {
    return this.showModuleSettings && this.contentFeatures.length > 0;
  }

  get showIntegrationModulesInput() {
    return this.showModuleSettings;
  }

  get showAnalyticsModulesInput() {
    return this.showModuleSettings && this.analyticsFeatures.length > 0;
  }

  /** Content, integration, and analytics modules apply to standard bot domains only. */
  get showModuleSettings(): boolean {
    return ![BotDomain.WlcmHome, BotDomain.Wedding].includes(this.value.domain);
  }

  get contentFeatures(): SupportedFeature[] {
    return DOMAIN_FEATURE_MAP[this.value.domain] || [];
  }

  get integrationFeatures(): SupportedFeature[] {
    return INTEGRATION_FEATURES;
  }

  get analyticsFeatures(): SupportedFeature[] {
    return ANALYTICS_FEATURES;
  }

  get environmentSelectOptions(): SelectOption[] {
    return [
      {
        value: 'staging',
        label: 'Staging',
      },
      {
        value: 'production',
        label: 'Production',
      },
    ];
  }
}
